const messages = {
  'page.qr-codes.title': 'QR code generator',
  'page.qr-codes.panel.title': 'Customise your QR code',
  'page.qr-codes.preview': 'Preview',
  'page.qr-codes.preview.alt': 'Preview of QR code',
  'page.qr-codes.details.url': 'URL',
  'page.qr-codes.appearance.logos': 'Logos',
  'page.qr-codes.appearance.emojis': 'Emojis',
  'page.qr-codes.appearance.include-image': 'Include an image on this QR code?',
  'page.qr-codes.appearance.bg-colour': 'Background',
  'page.qr-codes.appearance.code-colour': 'Code',
  'page.qr-codes.appearance.corner-colour': 'Corner',
  'page.qr-codes.filename': 'File name',
  'page.qr-codes.btn.download': 'Download',
  'page.qr-codes.btn.copy': 'Copy',
  'page.qr-codes.reset': 'Reset',
  'page.qr-codes.notification.copied': 'QR code copied',
}

export default messages
